import React, { type FC } from 'react';
import type { OrNull } from '../../../typings/utils';
import type { SSOConfig } from '../../common/api-client';

interface UserLinkProps {
  id: string;
  ssoConfig: OrNull<SSOConfig>;
}

const UserIdLink: FC<UserLinkProps> = ({ id, ssoConfig }) => {
  return (
    <a
      href={`${ssoConfig?.url}/auth/admin/master/console/#/realms/${ssoConfig?.realm}/users/${id}`}
    >
      {id}
    </a>
  );
};

export default UserIdLink;
